import { signal } from '@preact/signals';

/**
 * Очередь toast-уведомлений: пуш — добавить, авто-удаление через 3 сек в компоненте.
 */
export const notifications = signal([]);

let notifId = 0;
export function notify(message) {
  notifId += 1;
  const id = notifId;
  notifications.value = [...notifications.value, { id, message }];
  setTimeout(() => {
    notifications.value = notifications.value.filter((n) => n.id !== id);
  }, 3000);
}

/**
 * Стек открытых модалок — нужен для корректной обработки Esc (закрыть верхнюю).
 */
export const modalStack = signal([]);

export function pushModal(modal) {
  modalStack.value = [...modalStack.value, modal];
}

export function popModal(id) {
  modalStack.value = modalStack.value.filter((m) => m.id !== id);
}

export function closeTopModal() {
  const stack = modalStack.value;
  if (stack.length === 0) return false;
  const top = stack[stack.length - 1];
  top.onClose?.();
  return true;
}

/**
 * Off-canvas drawer (мобильное меню). На десктопе не используется.
 */
export const drawerOpen = signal(false);

export function openDrawer() {
  drawerOpen.value = true;
}

export function closeDrawer() {
  drawerOpen.value = false;
}

export function toggleDrawer() {
  drawerOpen.value = !drawerOpen.value;
}
